var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-filter"},_vm._l((_vm.allCbx),function(cbx){return _c('Checkbox',{key:cbx.value,staticClass:"checkbox",attrs:{"id":cbx.value,"title":cbx.title,"value":_vm.isChecked[cbx.value],"rounded":false},on:{"change":function($event){return _vm.updateCheckboxes(cbx.value, ...arguments)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }